
import { GroupLeaderRequest } from "@/types/admin-requests";
import { formatDistanceToNow } from "date-fns";
import { sv } from "date-fns/locale";
import { Badge } from "@/components/ui/badge";

interface RequestInfoProps {
  request: GroupLeaderRequest;
}

export const RequestInfo = ({ request }: RequestInfoProps) => {
  // Format the creation date
  const formattedCreatedAt = request.created_at
    ? formatDistanceToNow(new Date(request.created_at), { 
        addSuffix: true,
        locale: sv 
      })
    : "Okänt datum";

  // Add a small debug message in the console
  console.log(`RequestInfo for ${request.id}:`, {
    status: request.status,
    email_sent: request.email_sent,
    emailSentType: typeof request.email_sent
  });

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <p className="text-sm font-medium">Email</p>
        <p className="text-sm text-muted-foreground">
          {request.email}
        </p>
      </div>
      <div>
        <p className="text-sm font-medium">Status</p>
        <div className="flex items-center gap-2">
          <p className="text-sm text-muted-foreground capitalize">
            {request.status === 'pending' ? 'Väntar på godkännande' :
             request.status === 'approved' ? 'Godkänd' : 'Avslagen'}
          </p>
          {request.status === 'approved' && (
            <Badge variant={request.email_sent ? "success" : "outline"} className={!request.email_sent ? "border-amber-500 text-amber-700 bg-amber-50" : ""}>
              {request.email_sent ? 'Inbjudan skickad' : 'Inbjudan ej skickad'}
            </Badge>
          )}
        </div>
      </div>
      <div>
        <p className="text-sm font-medium">Skapad</p>
        <p className="text-sm text-muted-foreground">
          {formattedCreatedAt}
        </p>
      </div>
    </div>
  );
};
